import $ from 'jquery';
import 'jquery-datetimepicker';

export default function setupDateTimePicker() {
  const container = $('body');
  const defaults = {
    formatDate: 'd.m.y',
    format: 'd.m.Y H:i',
    allowBlank: true,
    defaultSelect: false,
    validateOnBlur: false,
    lang: 'pl',
    step: 30,
    mask: true,
    yearStart: new Date().getFullYear() - 2,
    yearEnd: new Date().getFullYear() + 2,
    dayOfWeekStart: 1
  };

  const entries = container.find('input.datetimepicker');

  entries.each(function(index, entry) {
    const $entry = $(entry);
    const options = $entry.data('datepicker-options') || {};
    const combinedOptions = $.extend({}, defaults, options);
    $entry.datetimepicker(combinedOptions);
  });
}